import { useProperty } from '@spotify-internal/remote-config-integration-react';

import { useServerSideConstants } from 'providers/ServerSideConstantsProvider';

import { enableStandaloneSearchPage } from './remote-config/properties';
import { Vertical } from './vertical';

export default function useStandaloneSearchEnabled() {
  const {
    verticalConfig: { verticalName },
  } = useServerSideConstants();
  const propertyEnabled = useProperty(enableStandaloneSearchPage);
  const isConsumer = verticalName === Vertical.CONSUMER;

  return propertyEnabled && isConsumer;
}
